import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=32a4e8a8&scoped=true&"
import script from "./finance.vue?vue&type=script&lang=js&"
export * from "./finance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a4e8a8",
  null
  
)

export default component.exports